export const SET_CITY = "SET_CITY"

export function setCity(city) {
  return {type: SET_CITY, city: city}
}
